var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFactory = function SvgFactory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.5 4.75a.75.75 0 0 0-1.293-.517l-5 5.25A.75.75 0 0 0 3 10v6c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-1.244-.564L14.5 8.347V4.75a.75.75 0 0 0-1.293-.517L9.5 8.125zm4.744 5.815L19 6.403v8.847H4.5V10.3L8 6.625V10a.75.75 0 0 0 1.293.517L13 6.625V10a.75.75 0 0 0 1.244.565M3.75 18.25a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgFactory;